
import Vue from 'vue';
import Vuex from 'vuex';

// each Vuex store is kept in a seperate module
import API from '_GLOBAL/store/API';
import authentication from '_GLOBAL/store/authentication';
import loading from '_GLOBAL/store/loading';
import resources from '_GLOBAL/store/resources';
import authorization from '_GLOBAL/store/authorization';
import notifySMS from '_GLOBAL/store/notifySMS';
import notifyTemplates from '_GLOBAL/store/notifyTemplates';
import resetPassword from '_GLOBAL/store/resetPassword';
import person from '_GLOBAL/store/person';

import global from './global';
import bookings from './bookings';
import payments from './payments';
import notifications from './notifications';
import messages from './messages';
import people from './people';
import client from './client';
import order from './order';
import subscriptions from './subscriptions';
import billing from '../../../global/store/billing';
import permissions from './permissions';

Vue.use(Vuex);

const store = () => new Vuex.Store({
  modules: {
    API,
    authentication,
    loading,
    resources,
    resetPassword,
    authorization,
    notifySMS,
    notifyTemplates,
    bookings,
    payments,
    notifications,
    global,
    messages,
    people,
    client,
    order,
    subscriptions,
    person,
    billing,
    permissions
  },
});

export default store;
